// extracted by mini-css-extract-plugin
module.exports = {"button":"capacitor-CollectionButton__button--3pwkI"};